import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { rem } from 'polished';
import theme from 'styled-theming';
import media from '../../tools/media';
import { prefix } from '../../tools/settings';
var fontColor = theme('mode', {
  light: 'var(--dentsu-color-black)',
  grey: 'var(--dentsu-color-black)',
  dark: 'var(--dentsu-color-white)'
});
export var StyledBulletedList = styled.ul.withConfig({
  displayName: "BulletedListstyles__StyledBulletedList",
  componentId: "sc-1sjj7w-0"
})(["padding-left:", ";margin:0;"], rem(16));
export var StyledBulletedListItem = styled.li.attrs({
  className: "".concat(prefix, "-bulleted-list__item")
}).withConfig({
  displayName: "BulletedListstyles__StyledBulletedListItem",
  componentId: "sc-1sjj7w-1"
})(["font-size:var(--dentsu-font-size-14);line-height:", ";color:", ";", " + .", "-bulleted-list__item{margin-top:", ";}"], rem(20), fontColor, media.xxxlarge(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: var(--dentsu-font-size-16);\n    line-height: ", ";\n  "])), rem(24)), prefix, rem(8));